import styled from 'styled-components';
import { colors } from 'styles/colors';

export const StyledDivider = styled.hr<{ position: 'x' | 'y' }>`
  border: none;
  margin: 0;

  ${({ position }) => (position === 'x' ? `
    border-top: 1px solid ${colors.stroke['soft-200']};
    width: 100%;
  ` : `
    border-left: 1px solid ${colors.stroke['soft-200']};
    height: 100%;
  `)}
`;
